export default __webpack_public_path__ + "static/media/Logo_outline.dc4c54ef.svg";